var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _MedicModel;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, hasMany } from "@ember-data/model";
import { service } from "@ember/service";
import HealthCentre from "core/models/health-centre";
import MedicsPatient from "core/models/medics-patient";
import TermsOfUseService from "core/services/terms-of-use";
import Creator from "./creator";
import TherapeuticalArea from "./therapeutical-area";
let MedicModel = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("string"), _dec6 = attr("string"), _dec7 = attr("string"), _dec8 = attr("string"), _dec9 = attr("string"), _dec10 = attr("string"), _dec11 = attr("string"), _dec12 = attr("string"), _dec13 = attr("number"), _dec14 = attr("string"), _dec15 = attr("string"), _dec16 = attr("date"), _dec17 = attr("boolean"), _dec18 = attr("string"), _dec19 = attr("boolean"), _dec20 = attr("boolean"), _dec21 = attr("date"), _dec22 = attr("boolean"), _dec23 = attr("date"), _dec24 = attr(), _dec25 = attr("number"), _dec26 = attr(), _dec27 = attr(), _dec28 = attr("string"), _dec29 = attr(), _dec30 = attr("boolean"), _dec31 = attr("boolean"), _dec32 = attr("string"), _dec33 = attr("boolean"), _dec34 = attr({
  defaultValue() {
    return {};
  }
}), _dec35 = hasMany("health-centre", {
  async: false,
  inverse: null
}), _dec36 = hasMany("medics-patient", {
  async: false,
  inverse: "medic"
}), _class = (_MedicModel = class MedicModel extends Creator {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "termsOfUse", _descriptor, this);
    _initializerDefineProperty(this, "role", _descriptor2, this);
    _initializerDefineProperty(this, "email", _descriptor3, this);
    _initializerDefineProperty(this, "phone", _descriptor4, this);
    _initializerDefineProperty(this, "fax", _descriptor5, this);
    _initializerDefineProperty(this, "address", _descriptor6, this);
    _initializerDefineProperty(this, "city", _descriptor7, this);
    _initializerDefineProperty(this, "postcode", _descriptor8, this);
    _initializerDefineProperty(this, "professionalId", _descriptor9, this);
    // IDNPS is the Identifiant National de Professionnel de Santé
    _initializerDefineProperty(this, "idnps", _descriptor10, this);
    _initializerDefineProperty(this, "secureEmail", _descriptor11, this);
    _initializerDefineProperty(this, "practiceLocation", _descriptor12, this);
    _initializerDefineProperty(this, "practiceSetting", _descriptor13, this);
    _initializerDefineProperty(this, "acceptedTermsOfUseVersion", _descriptor14, this);
    _initializerDefineProperty(this, "forceFinessForCnamRetrieval", _descriptor15, this);
    _initializerDefineProperty(this, "dmpAdapterName", _descriptor16, this);
    _initializerDefineProperty(this, "lastDmpDocumentsSearchDate", _descriptor17, this);
    _initializerDefineProperty(this, "canUseDmpRetrievalUpperLimit", _descriptor18, this);
    _initializerDefineProperty(this, "forceIdentifierForInsRetrieval", _descriptor19, this);
    _initializerDefineProperty(this, "insAccessDisabled", _descriptor20, this);
    _initializerDefineProperty(this, "twoFactorAuthenticationEnabled", _descriptor21, this);
    _initializerDefineProperty(this, "passwordChangedAt", _descriptor22, this);
    _initializerDefineProperty(this, "isSuperUser", _descriptor23, this);
    _initializerDefineProperty(this, "createdAt", _descriptor24, this);
    _initializerDefineProperty(this, "days", _descriptor25, this);
    _initializerDefineProperty(this, "preferredTime", _descriptor26, this);
    _initializerDefineProperty(this, "disabledNotificationTypes", _descriptor27, this);
    _initializerDefineProperty(this, "disabledAlertTypes", _descriptor28, this);
    _initializerDefineProperty(this, "professionalCategory", _descriptor29, this);
    _initializerDefineProperty(this, "specialities", _descriptor30, this);
    _initializerDefineProperty(this, "refreshTokensEnabled", _descriptor31, this);
    _initializerDefineProperty(this, "isInDiabetowiseTreatmentGroup", _descriptor32, this);
    _initializerDefineProperty(this, "aphCode", _descriptor33, this);
    /** A flag to activate matchlab bio matching page */
    _initializerDefineProperty(this, "useNewBioMatchingPage", _descriptor34, this);
    _initializerDefineProperty(this, "associatedData", _descriptor35, this);
    _initializerDefineProperty(this, "healthCentres", _descriptor36, this);
    _initializerDefineProperty(this, "medicsPatients", _descriptor37, this);
    _defineProperty(this, "isMedic", true);
  }
  get lastPasswordEditDate() {
    return this.passwordChangedAt || this.createdAt;
  }
  get shouldChangePassword() {
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    return this.lastPasswordEditDate < oneYearAgo;
  }

  /**
   * Check if the current user is one of the given roles.
   * @return true if the current user is one of the roles passed as parameter
   * @example
   * medic.hasRole("doctor", "contract_research_organisation", "nurse_lead")
   */
  hasRole(...args) {
    return args.includes(this.role);
  }
  get isAcceptedTermsOfUse() {
    return this.acceptedTermsOfUseVersion == this.termsOfUse.currentVersion;
  }
  get primaryHealthCenter() {
    return this.healthCentres[0];
  }
  get therapeuticalArea() {
    return this.primaryHealthCenter?.therapeuticalArea ?? null;
  }
  get therapeuticalAreas() {
    return this.healthCentres.map(hc => hc.therapeuticalArea);
  }
  get therapeuticalAreaIds() {
    return this.therapeuticalAreas.map(area => area?.id);
  }
  get followUpReasonIdsFromHealthCentres() {
    return [...new Set(this.therapeuticalAreas.map(ta => ta?.followUpReasons.map(fur => fur.id)).flat())];
  }
  get initials() {
    return [this.firstName?.charAt(0), this.lastName?.charAt(0)].join("").trim();
  }
}, _defineProperty(_MedicModel, "nonDisplayableRoles", ["contract_research_organisation", "third_party_server", "test_bot", "internal_server", "waiting", "nothing"]), _MedicModel), _descriptor = _applyDecoratedDescriptor(_class.prototype, "termsOfUse", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "role", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "phone", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "fax", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "address", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "city", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "postcode", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "professionalId", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "idnps", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "secureEmail", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "practiceLocation", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "practiceSetting", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "acceptedTermsOfUseVersion", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "forceFinessForCnamRetrieval", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "dmpAdapterName", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "lastDmpDocumentsSearchDate", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "canUseDmpRetrievalUpperLimit", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "forceIdentifierForInsRetrieval", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "insAccessDisabled", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "twoFactorAuthenticationEnabled", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "passwordChangedAt", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "isSuperUser", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "days", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "preferredTime", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "disabledNotificationTypes", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "disabledAlertTypes", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "professionalCategory", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "specialities", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "refreshTokensEnabled", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "isInDiabetowiseTreatmentGroup", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "aphCode", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "useNewBioMatchingPage", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "associatedData", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "healthCentres", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "medicsPatients", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MedicModel as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.